
document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('toggleFiltro');
    const menu = document.getElementById('menuFiltro');
    const selected = document.getElementById('selectedOption');
    const inputBusqueda = document.getElementById('search');
    let letraActiva = '';
    let categoriaActiva = '0';
    let plantaActiva = '0';



    //Cambio de vista de galeria a lista y mapa
    $(document).on('click', '.filter-gallery', function(){
        $('#contenedor-galeria').css('display', 'block');
        $('.plantas-mapa').css('display', 'none');
        $('.mapa-galeria').css('display', 'none');
        $('#contenedor-items').removeClass('lista');
        $('#contenedor-items').removeClass('lista-mapa');
        $('#contenedor-items').addClass('galeria');
        $(this).css('border', '1px solid #FE6A00');
        $(this).children('img').attr('src', 'storage/icons/galeria_orange.png');
        $('.filter-map').css('border', '1px solid gray');
        $('.filter-map').css('color', 'gray');
        $('.filter-map').css('background-color', 'transparent');
        $('.filter-list').css('border', '1px solid gray');
        $('.filter-list').children('img').attr('src', 'storage/icons/lista_gray.png');
        // Resetear letra y re-filtrar sin filtro por letra
        letraActiva = '';
        document.querySelectorAll('.letra-filtro').forEach(l => l.classList.remove('active'));
        filtrarTiendas(true, false, true, false);
    });
    $(document).on('click', '.filter-list', function(){
        $('#contenedor-galeria').css('display', 'block');
        $('.plantas-mapa').css('display', 'none');
        $('.mapa-galeria').css('display', 'none');
        $('#contenedor-items').removeClass('galeria');
        $('#contenedor-items').removeClass('lista-mapa');
        $('#contenedor-items').addClass('lista');
        $(this).css('border', '1px solid #FE6A00');
        $(this).children('img').attr('src', 'storage/icons/lista_orange.png');
        $('.filter-map').css('border', '1px solid gray');
        $('.filter-map').css('color', 'gray');
        $('.filter-map').css('background-color', 'transparent');
        $('.filter-gallery').css('border', '1px solid gray');
        $('.filter-gallery').children('img').attr('src', 'storage/icons/galeria_gray.png');
        // Resetear letra y re-filtrar sin filtro por letra
        filtrarTiendas(true, true, true, false);
    });
    $(document).on('click', '.filter-map', function(){
        $('#contenedor-galeria').css('display', 'flex');
       
        $('.plantas-mapa').css('display', 'flex');
        $('.mapa-galeria').css('display', 'block');
        $('#contenedor-items').removeClass('galeria');
        $('#contenedor-items').removeClass('lista');
        $('#contenedor-items').addClass('lista-mapa');
        $(this).css('border', '1px solid #FE6A00');
        $(this).css('color', '#ffffff');
        $(this).css('background-color', '#FE6A00');
        $('.filter-list').css('border', '1px solid gray');
        $('.filter-list').children('img').attr('src', 'storage/icons/lista_gray.png');
        $('.filter-gallery').css('border', '1px solid gray');
        $('.filter-gallery').children('img').attr('src', 'storage/icons/galeria_gray.png');
        // Resetear letra y re-filtrar sin filtro por letra
        letraActiva = '';
        document.querySelectorAll('.letra-filtro').forEach(l => l.classList.remove('active'));
        filtrarTiendas(true, false, true, true);
    });
    //Cambio de planta en el mapa
    $(document).on('click', '.planta-baja', function () {
        $('.mapa-base').attr('src', 'storage/locales/mapa-general-0.png');
        $(".mapa-tienda").removeClass('activo');
        $(this).css('background-color', '#FE6A00');
        $(this).css('color', '#ffffff');
        $(this).css('border', '1px solid #FE6A00');
        $('.planta-sotano').css('background-color', 'transparent');
        $('.planta-sotano').css('color', 'gray');
        $('.planta-sotano').css('border', '1px solid gray');
        plantaActiva = '0';
        filtrarTiendas(true, false, true, true); 
    });
    $(document).on('click', '.planta-sotano', function () {
        $('.mapa-base').attr('src', 'storage/locales/mapa-general-1.png');
        $(".mapa-tienda").removeClass('activo');
        $(this).css('background-color', '#FE6A00');
        $(this).css('color', '#ffffff');
        $(this).css('border', '1px solid #FE6A00');
        $('.planta-baja').css('background-color', 'transparent');
        $('.planta-baja').css('color', 'gray');
        $('.planta-baja').css('border', '1px solid gray');
        plantaActiva = '-1';
        filtrarTiendas(true, false, true, true);
    });

    if(toggle){
        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
        });
        document.getElementById('dropdownFiltro').addEventListener('click', function (e) {
            e.stopPropagation(); // Evita que se cierre al hacer clic dentro del dropdown
        });
    
        document.addEventListener('click', function (e) {    
            // Solo cerrar si el clic fue fuera del menú y fuera del toggle
            if (!menu.contains(e.target) && !toggle.contains(e.target)) {
                menu.style.display = 'none';
            }
        });
    }
    

    // Filtro por letra
    document.querySelectorAll('.letra-filtro').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            letraActiva = this.dataset.letra || '';
            // Activar visualmente la letra
            document.querySelectorAll('.letra-filtro').forEach(l => l.classList.remove('active'));
            this.classList.add('active');

            filtrarTiendas();
        });
    });

    // Filtro por texto
    if(inputBusqueda){
        inputBusqueda.addEventListener('input', function () {
            const enModoMapa = $('#contenedor-items').hasClass('lista-mapa');
            filtrarTiendas(true, true, true, enModoMapa);
        });
    }

    if(toggle){
        // Filtro por categoría (dropdown personalizado con radios)
        document.querySelectorAll('#menuFiltro input[type=radio]').forEach(input => {
            input.addEventListener('change', function () {
                categoriaActiva = this.value;
                selected.textContent = this.parentElement.textContent.trim();
                menu.style.display = 'none';
                const enModoMapa = $('#contenedor-items').hasClass('lista-mapa');
                filtrarTiendas(true, true, true, enModoMapa);
            });
        });
    }

    function filtrarTiendas(filtroTexto = true, filtroLetra = true, filtroCategoria = true, filtroPlanta = false) {
        const texto = inputBusqueda.value.toLowerCase();
        const tiendas = document.querySelectorAll('.item-galeria');

        tiendas.forEach(tienda => {
            const nombre = tienda.dataset.nombre?.toLowerCase() || '';
            const cat = tienda.dataset.categoria || '';
            const planta = tienda.dataset.planta || '';

            const coincideTexto = !filtroTexto || texto.length < 3 || nombre.includes(texto);
            const coincideLetra = !filtroLetra || !letraActiva || nombre.startsWith(letraActiva.toLowerCase());
            const coincideCategoria = !filtroCategoria || categoriaActiva === "0" || cat === categoriaActiva;
            const coincidePlanta = !filtroPlanta || planta === plantaActiva || planta === 'ambas';

            if (coincideTexto && coincideLetra && coincideCategoria && coincidePlanta) {
                tienda.style.display = '';
            } else {
                tienda.style.display = 'none';
            }
        });
    }
});




